import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useAxios } from '../context/AxiosContext';
import { MarketingResponseStatus } from '../components/Marketing/EngagementCenterContent';

export function useSSOToEngagementCenter({ trackId }: { trackId?: string }) {
  const { authAxios } = useAxios();

  const ssoRequest = useCallback(async () => {
    try {
      const response = await authAxios.get(`/marketing`);
      return response.data;
    } catch (e) {
      return { status: MarketingResponseStatus.ERROR };
    }
  }, [authAxios]);

  return useQuery(['marketing', trackId], ssoRequest, { refetchOnWindowFocus: false, suspense: true });
}
